import _ from 'underscore';

export default class OrderableItem {
  amount: number = 0;
  description?: string;
  editionDescription?: string;
  editionId?: string;
  enterprise: boolean = false;
  billingType?: string;
  licenseType?: string;
  monthsValid: number = 12;
  orderableItemId?: string;
  publiclyAvailable: boolean = true;
  renewalAmount: number = 0;
  saleType?: string;
  starter: boolean = false;
  unitCount: number = 0;
  unitLabel: string = 'USER';

  constructor(options: OrderableItem, product: OrderableItem) {

    Object.assign(this, options, _.pick(product, 'productKey', 'parentKey', 'productType', 'productDescription', 'parentDescription', 'billingType'));

    this.unitCount          = (this.unitCount === 987654321) ? -1 : this.unitCount;
    this.editionDescription = this.editionDescription?.replace(/enterprise /i, '');
    this.description        = this.description?.replace(/enterprise /i, '');
  }
}
